import { TYPOGRAPHY } from './typography'

export const parseRem = (val: number) => {
  return `${(val / parseInt(TYPOGRAPHY.sizeBase)) * 1}rem`
}
